var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'BranchNotificationList'
      }
    }
  }, [_vm._v("通知總覽")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("檢視通知")])], 1)], 1)])]), _c('div', {
    staticClass: "card"
  }, [_vm.notification ? _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.notification.title))])]), _c('p', [_vm._v("發送時間: " + _vm._s(_vm.notification.publish_at))]), _vm.notification.related_url ? _c('p', [_vm._v("通知網址: "), _c('b-link', {
    attrs: {
      "href": _vm.notification.related_url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.notification.related_url))])], 1) : _vm._e(), _vm.notification.notify_type == 'important' ? _c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "danger"
    }
  }, [_vm._v("此為重要通知")]) : _vm._e(), _c('div', {
    staticClass: "mt-3",
    attrs: {
      "id": "notification_content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.htmlContent)
    }
  })], 1) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }